import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import currentVersion from '../version.json';

const VersionCheck = () => {
  useEffect(() => {
    let reloadScheduled = false;

    const clearBrowserCaches = async () => {
      if (!('caches' in window)) return;
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    };

    const reloadWithFreshAssets = async () => {
      try {
        await clearBrowserCaches();
      } catch (error) {
        console.error("Erro ao limpar cache antes de atualizar:", error);
      } finally {
        window.location.reload();
      }
    };

    const isTouchDevice = () => {
      if (typeof window === 'undefined') return false;
      return window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkVersion();
      }
    };

    const checkVersion = async () => {
      try {
        // Adiciona timestamp para evitar cache do próprio arquivo version.json
        // Usando caminho absoluto /version.json para evitar erro em sub-rotas
        const response = await fetch(`/version.json?t=${new Date().getTime()}`, {
            cache: 'no-store',
            headers: {
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
        });
        
        if (!response.ok) {
            console.warn("Falha ao buscar version.json:", response.status);
            return;
        }
        
        const latestVersion = await response.json();
        
        console.log(`[VersionCheck] Local: ${currentVersion.version} | Servidor: ${latestVersion.version}`);

        // Se a versão do servidor for maior que a versão local
        if (latestVersion.version && currentVersion.version && 
            latestVersion.version !== currentVersion.version) {
          
          console.log(`Nova versão detectada: ${latestVersion.version} (Atual: ${currentVersion.version})`);

          if (isTouchDevice()) {
            if (reloadScheduled) return;
            reloadScheduled = true;
            toast.info("Nova versão detectada. Atualizando automaticamente...", {
              toastId: "version-update-auto-toast",
              position: "top-center",
              autoClose: 1500,
              closeOnClick: false,
              draggable: false,
              closeButton: false
            });

            setTimeout(() => {
              reloadWithFreshAssets();
            }, 1200);
            return;
          }
          
          // Opcional: Mostrar um toast ou banner
          toast.info(
            <div className="d-flex flex-column gap-2">
              <span>Nova versão disponível!</span>
              <button 
                className="btn btn-sm btn-light text-primary fw-bold"
                onClick={reloadWithFreshAssets}
              >
                Atualizar Agora
              </button>
            </div>,
            {
              toastId: "version-update-toast", // Previne duplicação
              position: "bottom-right",
              autoClose: false,
              closeOnClick: false,
              draggable: false,
              closeButton: false
            }
          );
        }
      } catch (error) {
        console.error("Erro ao verificar versão:", error);
      }
    };

    // Verificar ao montar
    checkVersion();

    // Verificar a cada 5 minutos
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    
    // Verificar quando a janela ganha foco
    window.addEventListener('focus', checkVersion);
    window.addEventListener('pageshow', checkVersion);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', checkVersion);
      window.removeEventListener('pageshow', checkVersion);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null; // Componente invisível
};

export default VersionCheck;
